<template>
  <div>
    <v-card
      v-for="r in [1, 2, 3, 4]"
      :key="r"
      class="mb-3 mx-5"
    >
      <v-skeleton-loader type="article" />
    </v-card>
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>
<style lang="sass" scoped>
:deep .v-card
  border-radius: 10px !important
</style>
